/**
 * 注意：
 * 该model是在基座中引入的，不需要注册
 * ！！！！
 */

import { Store } from '@medlinker/fundamental';
import { GetV1PrescriptionsElectronicsCanContinueListResponse } from '../../apis/apis';
import {
  getV1PrescriptionsElectronicsCanContinueList,
  postV1ContinuePresApply,
} from '../../apis/prescription';

export interface QuickContinuationState {
  prescriptionList: GetV1PrescriptionsElectronicsCanContinueListResponse['list'];
  start: number;
  hasMore: boolean;
  limit: number;
  selectedArr: GetV1PrescriptionsElectronicsCanContinueListResponse['list'];
  needQuickContinuation: boolean;
  historyRecipe:
    | GetV1PrescriptionsElectronicsCanContinueListResponse['list'][0]
    | undefined;
  isInit: boolean;
}

const initState = {
  prescriptionList: [],
  start: 0,
  hasMore: true,
  limit: 10,
  selectedArr: [],
  needQuickContinuation: false,
  historyRecipe: undefined,
  isInit: true,
} as QuickContinuationState;

const model = {
  name: 'prQuickContinuation',
  state: initState,
  reducers: {
    addPrescriptrionList(
      state: QuickContinuationState,
      payload: QuickContinuationState['prescriptionList']
    ) {
      if (payload && payload.length) {
        state.prescriptionList.push(...payload);
      }
    },
    setStart(state: QuickContinuationState) {
      state.start = state.prescriptionList.length;
    },
    setHasMore(
      state: QuickContinuationState,
      payload: QuickContinuationState['hasMore']
    ) {
      state.hasMore = payload;
    },
    // 设置需要续方的处方信息，im中会获取信息发送续方消息
    sendQuickContinuationMessage(
      state: QuickContinuationState,
      payload: QuickContinuationState['selectedArr'][0]
    ) {
      state.selectedArr = [payload];
      state.needQuickContinuation = true;
    },
    setHistoryRecipe(
      state: QuickContinuationState,
      payload: QuickContinuationState['historyRecipe']
    ) {
      state.historyRecipe = payload;
    },
    setIsInit(
      state: QuickContinuationState,
      payload: QuickContinuationState['isInit']
    ) {
      state.isInit = payload;
    },
  },
  effects: {
    /** 加载可续方处方列表 */
    async loadPrescription(
      payload: {
        doctorId: number;
        start: QuickContinuationState['start'];
        limit: QuickContinuationState['limit'];
      },
      { dispatch }: Store
    ) {
      const res =
        await getV1PrescriptionsElectronicsCanContinueList().setParams({
          ...payload,
        });

      dispatch.prQuickContinuation!.addPrescriptrionList(res.list);
      dispatch.prQuickContinuation!.setHasMore(res.more);
      dispatch.prQuickContinuation!.setStart();
    },
    /** 验证是否可以续方 */
    async sendContinuation(payload: any, { dispatch }: Store) {
      const res = await postV1ContinuePresApply().setData({
        prescriptionId: payload.prescriptId || payload.prescriptionId,
        origin: 1,
      });

      return res;
    },
  },
};

export default model;
